import React from 'react';
import './Hyperlink.scss';

function Hyperlink({ hyperlinkData }) {
  return (
    <a className="hyperlink" href={hyperlinkData.href} target="_blank" rel="sponsored">
      {hyperlinkData.copy}
    </a>
  );
}

export default Hyperlink;
